import { title } from 'process';
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';

function SocialMedia(props: any){
    const [radioValue, setradioValue] = useState('English')
    const [selectedValue, setSelectedValue] = useState("English");
    const [languagesData, setLanguagesData] = useState([]);
    const [indianlanguagesData, setIndianLanguagesData] = useState([]);
    const [languagesValue, setLanguagesValue] = useState(radioValue);
    const [voicetonesData, setVoicetonesData] = useState([])
    const [voicetonesValue, setVoicetonesValue] = useState('')
    const [writingStylesData,setwritingStylesData] = useState([])
    const [writingStylesValue,setwritingStylesValue] = useState('')
    const [textareaValue, setTextareaValue] = useState('')
    const [topicValue, setTopicValue] = useState('')
    const [totalPostsValue, setTotalPostsValue] = useState(5)
    const [audienceValue , setAudienceValue] = useState('')
    const [totalMonthsValue, setTotalMonthsValue] = useState(10)
    const [threadsPerWeekValue, setThreadsPerWeekValue] = useState(5)
    const [articlesPerWeekValue, setArticlesPerWeekValue] = useState(5)
    const [articleValue, setArticleValue] = useState('')
    const [industryValue, setIndustryValue] = useState('')
    const [postLengthValue, setPostLengthValue] = useState('390 - 400 words')
    const [postValue, setPostValue] = useState('')
    const [commentTypeValue, setCommentTypeValue] = useState('appreciative')
    const [lengthValue, setLengthValue] = useState(300)
    const [jobDescriptionValue, setJobDescriptionValue] = useState('')
    const [nameValue, setNameValue] = useState('')
    const [titleCompanyValue, setTitleCompanyValue] = useState('')
    const [totalValue, setTotalValue] = useState(10)
    const [postsperweekValue,setPostsperweekValue] = useState(5)
    const [totalKeywordsValue, setTotalKeywordsValue] = useState(10)
    const [totalTitlesValue, setTotalTitlesValue] = useState(10)
    const [totalDescriptionsValue, setTotalDescriptionsValue] = useState(10)
    const [keywordsValue, setKeywordsValue] = useState('')
    const [totalHashtagsValue, setTotalHashtagsValue] = useState(10)
    const [totalIdeasValue, setTotalIdeasValue] = useState(10)
    const [jobRoleValue, setJobRoleValue] = useState('')
    const [customerTweetValue, setCustomerTweetValue] = useState('')
    const [contentValue, setContentValue] = useState('')
    const [videoDescriptionValue,setVideoDescriptionValue] = useState('')
    const [callToActionValue, setCallToActionValue] = useState('to click the subscribe button')
    const [transcriptValue, setTranscriptValue] = useState('')
    const [totalHeadlines, setTotalHeadlines] = useState(20)
    const [descriptionLengthValue, setDescriptionLengthValue] = useState('30 to 35 characters')
    const [headlinesLengthValue, setHeadlinesLengthValue] = useState('90 to 100 characters')
    const [totalTagsValue, setTotalTagsValue] = useState(10)
    const [videosPerWeekValue, setVideosPerWeekValue] = useState(5)
    const [keyword, setKeyword] = useState('')
    const promptTitle = `# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"${props.templateValue}\"](https://www.stwbot.com/)_\"\n---\n`
    let copyWritingPrompt: any ={
        'Facebook Post Ideas':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert Facebook marketer. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Generate ${totalPostsValue} ideas for Facebook posts on the topic "${topicValue}" that will engage the target audience - "${audienceValue}". Include a CTA and hashtags wherever possible.`, 
        'Facebook Group Post':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert Facebook marketer. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Give me a list of ${totalPostsValue} interesting and engaging questions to post on my Facebook Group about "${topicValue}".`, 
        'Facebook Ad Creator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert Facebook marketer with expertise in Facebook Ads. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please create ad copy for the product/service "${topicValue}". Please use the following guidelines: Create a compelling headline that grabs attention and highlights the main benefit of the product/service. The headline should be between 30-40 characters and its description field should be 20-25 characters. Then, create the primary ad text field. Use clear and concise language in the primary ad text field copy that focuses on the benefits of the product/service and addresses any potential objections. Include a strong call to action that encourages users to take the desired action. The primary ad text field should be 120-125 characters. Research the target audience demographics such as age, gender, location, interests, and other characteristics that would help you to have a better understanding of the target audience and create an ad that would be more appealing to them.`, 
        'Facebook Post Calendar':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert Facebook marketer. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Please create a Facebook Post Calendar for ${totalMonthsValue} months based on your product/service "${topicValue}" for your target audience "${audienceValue}". There should be ${totalMonthsValue} Facebook posts scheduled each week of the month. Every Facebook post should have a catchy headline and description. Try to use unique emojis in the description. The description should have a hook and entice the readers. The table should have actual dates in the future. Each month should have its own table. The table columns should be: date, post idea description. Please organize each Facebook post in the table so that it looks like a calendar. Do not self reference. Do not explain what you are doing. Reply back only with the table.`, 
        'Generate Instagram Carousel':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an Instagrammer with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Create an Instagram carousel on "${topicValue}". There should be around 8 to 10 slides. Write down details on all the slides with titles. Generate an exact content example for every slide. After writing the carousel slides, please add a separator line. Then generate an Instagram post description in just a few sentences for the carousel. Include emojis and the Instagram hashtags in the description. Try to use unique emojis in the content. The description should have a hook and entice the readers. Do not repeat yourself. Do not self reference. Do not explain what you are doing. Do not explain what you are going to do. Start directly by writing down the slide details.`, 
        'Generate Instagram Caption':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an Instagrammer with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Write a Instagram post description in just a few sentences for the post "${topicValue}". Make the description readable by formatting with new lines. Include emojis and the Instagram hashtags in the description. Try to use unique emojis in the description. The description should have a hook and entice the readers. Do not repeat yourself. Do not self reference. Do not explain what you are doing. Do not explain what you are going to do. Start directly by writing down the description.`, 
        'Instagram Post Calendar':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an Instagrammer with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Please create a Instagram Post Calendar for ${totalMonthsValue} months based on your interests "${topicValue}". There should be ${articlesPerWeekValue} Instagram posts scheduled each week of the month. Every Instagram post should have a catchy description. Include emojis and the Instagram hashtags in the description. Try to use unique emojis in the description. The description should have a hook and entice the readers. The table should have actual dates in the future. Each month should have its own table. The table columns should be: date, post idea description, caption without hashtags, hashtags. Please organize each instagram post in the table so that it looks like a calendar. Do not self reference. Do not explain what you are doing. Reply back only with the table.`, 
        'LinkedIn Post Creator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a LinkedIn content creator. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Your content should be engaging, informative, and relevant LinkedIn posts for various professionals across different industries. Please include industry insights, personal experiences, and thought leadership while maintaining a genuine and conversational tone. Please create a post about the ${topicValue} for the ${industryValue} industry. Add emojis to the content when appropriate and write from a personal experience. The content should be between ${postLengthValue} long and spaced out so that it's easy for readers to scan through. Please add relevant hashtags to the post and encourage the readers to comment.`,  
        'LinkedIn Comment Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a LinkedIn influencer with a large following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please create ${lengthValue} ${commentTypeValue} comments in response to the following LinkedIn Post: "${postValue}".`,  
        'LinkedIn Bio Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert LinkedIn Bio creator. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Create a LinkedIn Bio for the following job description - "${jobDescriptionValue}". The bio should be ${lengthValue} characters long and should highlight the tops skills of the job mentioned.`,  
        'LinkedIn Connection Message':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a LinkedIn user who would like to make a connection. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please generate a connection message for the LinkedIn user with the name "${nameValue}". They have the position of ${titleCompanyValue}. The message should be between ${lengthValue}. Please make the message friendly and engaging. Do not directly mention their position.`,  
        'LinkedIn Ad Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a sales manager with expertise in LinkedIn Ads creation. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Generate ${lengthValue} compelling LinkedIn ad headlines about the topic "${topicValue}". The headlines should be between 140 to 150 characters long. After this, generate ${lengthValue} compelling LinkedIn ad descriptions about the topics "${topicValue}". The descriptions should be between 60 to 70 characters long.`, 
        'LinkedIn Hashtag Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a LinkedIn influencer with a large following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please generate ${topicValue} high performing hashtags for the following LinkedIn Post: "${postValue}".`, 
        'LinkedIn Post Calendar':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an LinkedIn professional with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Please create a LinkedIn Post Calendar for ${totalMonthsValue} months based on your interests "${topicValue}". There should be ${postsperweekValue} LinkedIn posts scheduled each week of the month. The Posts should be engaging, informative, and relevant to various LinkedIn professionals across different industries. Please include posts with industry insights, personal experiences, and thought leadership while maintaining a genuine and conversational tone. The markdown table should have actual dates in the future. Each month should have its own table. The table columns should be: Date, LinkedIn Post Idea, Hashtags. Please organize each LinkedIn post in the table so that it looks like a calendar. Do not self reference. Do not explain what you are doing. Reply back only with the table.`, 
        'Keywords For Pinterest':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a Pinterest marketing expert. Do not self reference. Do not explain what you are doing. Please provide me with ${totalKeywordsValue} high performing SEO keywords to use for Pinterest for the following topic: "${topicValue}"`,  
        'Generate Pin Titles':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a Pinterest SEO marketer and copywriter. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please provide me with ${totalTitlesValue} engaging Pinterest pin titles for the topic "${topicValue}". The titles should be between 90 to 100 characters.`,  
        'Generate Pin Descriptions':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. Do not self reference. You are a Pinterest SEO marketer and copywriter. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please write ${totalDescriptionsValue} Pinterest description that is between 490 to 500 characters for the following topic: "${topicValue}". Please include the following keywords "${keywordsValue}".`, 
        'Pinterest Hashtag Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a Pinterest marketer and influencer. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please generate ${totalHashtagsValue} popular hashtags for the following text: "${topicValue}".`,  
        'Pinterest Pin Calendar':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a Pinterest marketer and influencer with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please create a Pinterest Pin Calendar with ideas for engaging pins for ${threadsPerWeekValue} months based on the topic "${topicValue}". There should be ${totalMonthsValue} Pins scheduled each week of the month. The Pins should be casual, informative, and engaging. Please use simple and understandable words. Please include tips, personal experience, and fun facts in the Pins. The markdown table should have actual dates in the future. Each month should have its own table. The table columns should be: Date, Pinterest Pin Idea, Hashtags. Please organize each Pin idea in the table so that it looks like a calendar. Do not self reference. Do not explain what you are doing. Reply back only with the table.`, 
        'TikTok Video Ideas':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a TikTok marketer and influencer. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please generate ${totalIdeasValue} TikTok video ideas that have the potential to go viral for the topic "${topicValue}". Please include catchy titles and trending hashtags for each idea.`, 
        'TikTok Script Writer':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a TikTok marketer and influencer. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please write me a TikTok video script for the topic "${topicValue}". The target audience is "${audienceValue}". The length of the video should be less than ${lengthValue} long. The script needs to have a catchy title, follow the best practice of Tiktok videos, and get as much traction from the target audience as possible.`,  
        'TikTok Hashtag Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a TikTok influencer with a large following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please generate ${totalHashtagsValue} trending  hashtags for the following text: "${topicValue}".`, 
        'TikTok Post Calendar':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a TikTok creator and influencer. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Please create a TikTok content calendar with ideas for engaging TikToks for ${totalMonthsValue} months based on the topic "${topicValue}". There should be ${threadsPerWeekValue} videos scheduled each week of the month. The videos should be entertaining, informative, and engaging. Please use simple and understandable words. Please include tips, personal experience, and fun facts in the videos. The markdown table should have actual dates in the future. Each month should have its table. The table columns should be: Date, TikTok Idea, Hashtags, Trending songs. Please organize each TikTok idea in the table so that it looks like a calendar. Do not self reference. Do not explain what you are doing. Reply back only with the table.`, 
        'Engaging Twitter Thread':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a Twitter influencer with a large following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please create a thread about ${topicValue}. Add emojis to the thread when appropriate. The character count for each thread should be between 270 to 280 characters. Your content should be casual, informative, and an engaging Twitter thread. Please use simple and understandable words. Please include statistics, personal experience, and fun facts in the thread. Please add relevant hashtags to the post and encourage the readers join the conversation.`,  
        'Twitter Personalized Bio':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a professional Twitter bio generator. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please create a unique and eye-catching twitter bio with suitable emojis and informative bio for a ${jobRoleValue} job profile in the ${industryValue} industry who wants to showcase their skills and experience on their Twitter profile. The bio should be brief engaging and highlight the individual's professional accomplishments key strengths and unique selling points in a concise and attention-grabbing manner. The length of the bio should be between 150 to 160 characters. Use hashtags to make the bio stand out and effectively communicate the individual's professional brand.`,  
        'Convert Article Into Twitter Thread':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a professional copywriter and would like to convert your article into an engaging Twitter thread. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Add emojis to the thread when appropriate. The character count for each thread should be between 270 to 280 characters. Please add relevant hashtags to the post and encourage the Twitter users to join the conversation. Please turn the following article into a Twitter thread: "${articleValue}".`,  
        'Respond to Customers on Twitter':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a customer support agent who responds to customer tweets with empathy. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please create a response for a customer tweet. Break your response into individual tweets. The character count for each tweet should be between 270-280 characters. The customer tweet is "${customerTweetValue}"`, 
        'Twitter Hashtag Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a Twitter influencer with a large following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please generate ${totalHashtagsValue} high performing hashtags for the following text: "${contentValue}".`, 
        'Twitter Thread Calendar':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a Twitter professional with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Please create a Twitter Thread Calendar with ideas for engaging twitter threads for ${totalMonthsValue} months based on the topic "${topicValue}". There should be ${threadsPerWeekValue} Twitter threads scheduled each week of the month. The twitter threads should be casual, informative, and engaging. Please use simple and understandable words. Please include statistics, personal experience, and fun facts in the twitter threads. The markdown table should have actual dates in the future. Each month should have its own table. The table columns should be: Date, Twitter Thread Idea. Please organize each blog thread idea in the table so that it looks like a calendar. Do not self reference. Do not explain what you are doing. Reply back only with the table.`, 
        'YouTube Script Creator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a YouTuber with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Create a complete youtube video script for "${videoDescriptionValue}". The script should have a good introduction, between 4 to 5 segments and an conclusion. In the relevant segment ask the viewer ${callToActionValue}`,  
        'YouTube Shorts Script':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a YouTuber with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Create a YouTube Shorts video script for "${videoDescriptionValue}". The script is for YouTube shorts and should not be longer than 60 seconds. In the script where relevant, ask the viewer ${callToActionValue}`, 
        'YouTube Title &Descriptions':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a YouTuber with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Generate catchy YouTube titles and descriptions for a list of keywords - "${keywordsValue}". Only one title and one description should be generated for each keyword. The titles should not be more than 100 characters long. The descriptions should not be longer than 1000 characters long. The title and description should have the keywords in them. The title should be good for videos and not be generic titles. The titles should either be teaching the viewer about something in a visual way. The description should be long and contain multiple informational paragraphs about the topic. The description should also ask the viewer to ${callToActionValue}`,  
        'YouTube Transcript to Article':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert copywriter who is good at converting YouTube transcripts into articles. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. I will give you a YouTube transcript text and you will create an article based on it. Please intersperse short and long sentences. Utilize uncommon terminology to enhance the originality of the content. Please format the content in a professional format. Also generate a catchy page title and meta descriptions for the article. The page titles should be between 70 and 80 characters and should be optimized for the keyword "${keywordsValue}". The meta descriptions should be between 140 and 160 characters and should be optimized for the keyword "${keywordsValue}". The YouTube transcript text is - "${transcriptValue}"`,  
        'YouTube Ads Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a copywriter with expertise in YouTube Ad creation. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Generate ${totalHeadlines} compelling YouTube headlines and ${totalHeadlines} compelling descriptions for a video. The headlines should be between ${headlinesLengthValue} long. The descriptions should be between ${descriptionLengthValue} long. Do not use single quotes, double quotes or any other enclosing characters. The video is about "${videoDescriptionValue}"`, 
        'YouTube Tags Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a YouTuber with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Please generate ${totalTagsValue} YouTube Tags for the text that I give you. Please do not generate hashtags. If you generate anything that starts with the "#" character then ignore it. YouTube tags are complete keywords with spaces between the words. Please capitalize each work in the YouTube tag. Please put the YouTube tags in a markdown table. Please generate the YouTube tags for the text : "${videoDescriptionValue}".`,  
        'YouTube Video Calendar':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a YouTuber with a large fan following. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Please create a YouTube Video Calendar for ${totalMonthsValue} months based on your interests "${topicValue}". There should be ${videosPerWeekValue} videos scheduled each week of the month. The markdown table should have actual dates in the future. Each month should have its own table. The table columns should be: Date, Video Title, Video Description. The Video Title should be no longer than 100 characters. The Video description should describe what the video is about. Please organize each video in the table so that it looks like a calendar. Do not self reference. Do not explain what you are doing. Reply back only with the table.`
    }
    let templateValue: any = copyWritingPrompt[props.templateValue] ? copyWritingPrompt[props.templateValue] : ''
    useEffect(() => {
        setTextareaValue(templateValue)
    }, [templateValue])
    useEffect(() => {
        resetValue()
    }, [props.templateValue])
    useEffect(() => {
        const data: any = []
        for (const key in indianLanguages) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = indianLanguages[key];
            data.push(value)
        }
        setIndianLanguagesData(data) 
        const dataVoice: any = []
        for (const key in voicetones) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = voicetones[key];
            dataVoice.push(value)
        }
        setVoicetonesData(dataVoice) 
        const datawritingStyles:any = []
        for (const key in writingStyles) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = writingStyles[key];
            datawritingStyles.push(value)
        }
        setwritingStylesData(datawritingStyles)
    },[])
    const onChangeRadio = (event: any) => {
        const value = event.target.value;
        setSelectedValue(value);
        setradioValue(value)
        if(value === 'Other languages'){
            const data: any = []
            for (const key in languages) {
                const value: any = {
                    name: '',
                    value: ''
                }
                value.value = key;
                value.name = languages[key];
                data.push(value)
            }
            setLanguagesData(data)
            setLanguagesValue('Arabic')
        } else {
            setLanguagesValue(value)
            setLanguagesData([])
        }
    }
    const onChangeLanguages = (event: any) => {
        const value = event.target.value;
        setLanguagesValue(value)
    }
    const onChangeVoicetones = (event: any) => {
        const value = event.target.value
        setVoicetonesValue(value)
    }
    const onChangeWritingStyles = (event: any) => {
        const value = event.target.value
        setwritingStylesValue(value)
    }
    const onChangeTextarea = (event: any) => {
        const value = event.target.value
        setTextareaValue(value)
    }
    const onChangeTopicValue = (event: any) => {
        const value = event.target.value
        setKeyword(value)
        setTopicValue(value)
    }
    const onChangeTotalPosts = (event:any) => {
        const value = event.target.value
        setTotalPostsValue(value)
    }
    const onChangeAudience = (event:any) => {
        const value = event.target.value
        setAudienceValue(value)
    }
    const onChangeTotalMonths = (event: any) => {
        const value = event.target.value 
        setTotalMonthsValue(value)
    }
    const onChangeThreadsPerWeek = (event:any) => {
        const value = event.target.value 
        setThreadsPerWeekValue(value)
    }
    const onChangeArticlesPerWeek = (event:any) => {
        const value = event.target.value 
        setArticlesPerWeekValue(value)
    }
    const onChangeIndustry = (event:any) => {
        const value = event.target.value 
        setIndustryValue(value)
    }
    const onChangePostLength = (event:any) => {
        const value = event.target.value 
        setPostLengthValue(value)
    }
    const onChangePost = (event:any) => {
        const value = event.target.value
        setKeyword(value)
        setPostValue(value)
    }
    const onChangeCommentType = (event: any) => {
        const value = event.target.value
        setCommentTypeValue(value)
    }
    const onChangeLength = (event: any) => {
        const value = event.target.value
        setLengthValue(value)
    }
    const onChangeJobDescription = (event:any) => {
        const value = event.target.value
        setKeyword(value)
        setJobDescriptionValue(value)
    }
    const onChangeName = (event:any) => {
        const value = event.target.value
        setNameValue(value)
    }
    const onChangeTitleCompany = (event:any) => {
        const value = event.target.value
        setKeyword(value)
        setTitleCompanyValue(value)
    }
    const onChangeTotal = (event:any) => {
        const value = event.target.value
        setTotalValue(value)
    }
    const onChangePostsperweek = (event:any) => {
        const value = event.target.value
        setPostsperweekValue(value)
    }
    const onChangeTotalKeywords = (event:any) => {
        const value = event.target.value 
        setTotalKeywordsValue(value)
    }
    const onChangeTotalTitles = (event: any) => {
        const value = event.target.value
        setTotalTitlesValue(value)
    }
    const onChangeTotalDescriptions = (event: any ) => {
        const value = event.target.value 
        setTotalDescriptionsValue(value)
    }
    const onChangeKeywords = (event: any) => {
        const value = event.target.value
        setKeyword(value)
        setKeywordsValue(value)
    }
    const onChangeTotalHashtags = (event:any) => {
        const value = event.target.value
        setTotalHashtagsValue(value)
    }
    const onChangeTotalIdeas = (event:any) => {
        const value = event.target.value 
        setTotalIdeasValue(value)
    }
    const onChangeJobRole = (event:any) => {
        const value = event.target.value 
        setKeyword(value)
        setJobRoleValue(value)
    }
    const onChangeArticle = (event: any) => {
        const value = event.target.value 
        setKeyword(value)
        setArticleValue(value)
    }
    const onChangeCustomerTweet = (event:any) => {
        const value = event.target.value 
        setKeyword(value)
        setCustomerTweetValue(value)
    }
    const onChangeContent = (event: any) => {
        const value = event.target.value 
        setKeyword(value)
        setContentValue(value)
    }
    const onChangeVideoDescription = (event:any) => {
        const value = event.target.value 
        setKeyword(value)
        setVideoDescriptionValue(value)
    }
    const onChangeCallToAction = (event: any) => {
        const value = event.target.value  
        setCallToActionValue(value)
    }
    const onChangeTranscript = (event:any) => {
        const value = event.target.value
        setKeyword(value)
        setTranscriptValue(value)
    }
    const onChangeTotalHeadlines = (event: any) => {
        const value = event.target.value 
        setTotalHeadlines(value)
    }
    const onChangeDescriptionLength = (event:any) => {
        const value = event.target.value  
        setDescriptionLengthValue(value)
    }
    const onChangeHeadlinesLength = (event:any) => {
        const value = event.target.value 
        setHeadlinesLengthValue(value)
    }
    const onChangeTotalTags = (event:any) => {
        const value = event.target.value 
        setTotalTagsValue(value)
    }
    const onChangeVideosPerWeek = (event:any) => {
        const value = event.target.value 
        setVideosPerWeekValue(value)
    }
    const getButtonVisiblety = () => {
        const value = props.templateValue
        switch(value) {
            case 'Facebook Post Ideas':
                return topicValue && totalPostsValue && audienceValue ? false : true
            case 'Facebook Group Post':
                return topicValue && totalPostsValue ? false : true
            case 'Facebook Ad Creator':
                return topicValue ? false : true
            case 'Facebook Post Calendar':
                return topicValue && threadsPerWeekValue && totalMonthsValue && audienceValue ? false : true
            case 'Generate Instagram Carousel':
                return topicValue ? false : true
            case 'Generate Instagram Caption':
                return topicValue ? false : true
            case 'Instagram Post Calendar':
                return topicValue && articlesPerWeekValue && totalMonthsValue ? false : true
            case 'LinkedIn Post Creator':
                return topicValue && industryValue && postLengthValue ? false : true
            case 'LinkedIn Comment Generator':
                return postValue && lengthValue && commentTypeValue ? false : true
            case 'LinkedIn Bio Generator':
                return jobDescriptionValue && lengthValue ? false : true
            case 'LinkedIn Connection Message':
                return nameValue && lengthValue && titleCompanyValue ? false : true
            case 'LinkedIn Ad Generator':
                return topicValue && lengthValue ? false : true
            case 'LinkedIn Hashtag Generator':
                return postValue && totalValue ? false : true
            case 'LinkedIn Post Calendar':
                return topicValue && postsperweekValue && totalMonthsValue ? false : true
            case 'Keywords For Pinterest':
                return topicValue && totalKeywordsValue ? false : true
            case 'Generate Pin Titles':
                return topicValue && totalTitlesValue ? false : true
            case 'Generate Pin Descriptions':
                return topicValue && totalDescriptionsValue && keywordsValue ? false : true
            case 'Pinterest Hashtag Generator':
                return topicValue && totalHashtagsValue ? false : true
            case 'Pinterest Pin Calendar':
                return topicValue && totalMonthsValue && threadsPerWeekValue ? false : true
            case 'TikTok Video Ideas':
                return topicValue && totalIdeasValue ? false : true
            case 'TikTok Script Writer':
                return topicValue && lengthValue && audienceValue ? false : true
            case 'TikTok Hashtag Generator':
                return topicValue && totalHashtagsValue ? false : true
            case 'TikTok Post Calendar':
                return topicValue && totalMonthsValue && threadsPerWeekValue ? false : true
            case 'Engaging Twitter Thread':
                return topicValue ? false : true              
            case 'Twitter Personalized Bio':
                return jobRoleValue && industryValue ? false : true
            case 'Convert Article Into Twitter Thread':
                return articleValue ? false : true
            case 'Respond to Customers on Twitter':
                return customerTweetValue ? false : true
            case 'Twitter Hashtag Generator':
                return contentValue && totalHashtagsValue ? false : true
            case 'Twitter Thread Calendar':
                return topicValue && threadsPerWeekValue && totalMonthsValue ? false : true
            case 'YouTube Script Creator':
                return videoDescriptionValue && callToActionValue ? false : true               
            case 'YouTube Shorts Script':
                return videoDescriptionValue && callToActionValue ? false : true  
            case 'YouTube Title &Descriptions':
                return keywordsValue && callToActionValue ? false : true  
            case 'YouTube Transcript to Article':
                return transcriptValue && keywordsValue ? false : true  
            case 'YouTube Ads Generator':
                return totalHeadlines && headlinesLengthValue && descriptionLengthValue && videoDescriptionValue ? false : true
            case 'YouTube Tags Generator':
                return videoDescriptionValue && totalTagsValue ? false : true
            case 'YouTube Video Calendar':
                return topicValue && videosPerWeekValue && totalMonthsValue ? false : true
            default:
                return true;
        }
    }
    const executeTemplateButton = () => {
        props.executeTemplateButton(textareaValue,keyword)
    }
    const resetValue = () => {
        setTopicValue('')
        setTotalPostsValue(5)
        setAudienceValue('')
        setTotalMonthsValue(10)
        setThreadsPerWeekValue(5)
        setArticlesPerWeekValue(5)
        setArticleValue('')
        setIndustryValue('')
        setPostLengthValue('390 - 400 words')
        setPostValue('')
        setCommentTypeValue('appreciative')
        setLengthValue(300)
        setJobDescriptionValue('')
        setNameValue('')
        setTitleCompanyValue('')
        setTotalValue(10)
        setPostsperweekValue(5)
        setTotalKeywordsValue(10)
        setTotalTitlesValue(10)
        setTotalDescriptionsValue(10)
        setKeywordsValue('')
        setTotalHashtagsValue(10)
        setTotalIdeasValue(10)
        setJobRoleValue('')
        setCustomerTweetValue('')
        setContentValue('')
        setVideoDescriptionValue('')
        setCallToActionValue('to click the subscribe button')
        setTranscriptValue('')
        setTotalHeadlines(20)
        setDescriptionLengthValue('30 to 35 characters')
        setHeadlinesLengthValue('90 to 100 characters')
        setTotalTagsValue(10)
        setVideosPerWeekValue(5)
    }
    return(
        <div className='marketing'>
            <div className="row">
                <div className="col-sm-12 mt-2"><p>Description: Suggest 10 catchy blog post titles for a specific topic</p></div>
                <div className="col-sm-12 mt-2">
                    <div id="reverse-radio" className="mb-3">
                        {indianlanguagesData.map((item, i) => 
                            <Form.Check
                                key={i}
                                reverse
                                onChange={onChangeRadio}
                                label={item['name']}
                                checked={selectedValue === item['name']}
                                name="group1"
                                value={item['name']}
                                type='radio'
                                id={`reverse-radio-${i}`}
                            />
                        )}
                    </div>
                </div>
                {radioValue === "Other languages" && <div className="col-sm-4 mt-2">
                    <Form.Label htmlFor="languages">Languages:</Form.Label>
                    <Form.Select id="languages" 
                        value={languagesValue}
                        onChange={onChangeLanguages}
                    >
                        {languagesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>  
                </div>}
                <div className={"col-sm-"+(radioValue === "Other languages" ? "4" : "6")+" mt-2"}>
                    <Form.Label htmlFor="voicetones">Voice Tones:</Form.Label>
                    <Form.Select 
                        id="voicetones" 
                        aria-label="Default"
                        value={voicetonesValue}
                        onChange={onChangeVoicetones}
                    >
                        <option>Default</option>
                        {voicetonesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>  
                </div>
                <div className={"col-sm-"+(radioValue === "Other languages" ? "4" : "6")+" mt-2"}>
                    <Form.Label htmlFor="writingStyles">Writing Styles:</Form.Label>
                    <Form.Select 
                        id="writingStyles" 
                        aria-label="Default"
                        value={writingStylesValue}
                        onChange={onChangeWritingStyles}
                    >
                        <option>Default</option>
                        {writingStylesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>
                </div>
                {props.templateValue === 'Facebook Post Ideas' || 
                props.templateValue === "Facebook Group Post" ||
                props.templateValue === "Facebook Ad Creator" ||
                props.templateValue === "Generate Instagram Carousel" || 
                props.templateValue === "Generate Instagram Caption" ||
                props.templateValue === 'Instagram Post Calendar' || 
                props.templateValue === "LinkedIn Post Creator" || 
                props.templateValue === "LinkedIn Ad Generator" || 
                props.templateValue === "LinkedIn Post Calendar" || 
                props.templateValue === 'Generate Pin Descriptions' || 
                props.templateValue === 'Keywords For Pinterest' || 
                props.templateValue === 'Generate Pin Titles' || 
                props.templateValue === "Pinterest Hashtag Generator" || 
                props.templateValue === "Pinterest Pin Calendar" || 
                props.templateValue === 'TikTok Video Ideas' ||
                props.templateValue === "TikTok Script Writer" || 
                props.templateValue === "TikTok Hashtag Generator" || 
                props.templateValue === "TikTok Post Calendar" || 
                props.templateValue === 'Engaging Twitter Thread' || 
                props.templateValue === "Twitter Thread Calendar" || 
                props.templateValue === "Facebook Post Calendar" ||
                props.templateValue === "YouTube Video Calendar" ? <div 
                    className={"col-sm-" + (
                        props.templateValue === "LinkedIn Post Calendar" || 
                        props.templateValue === "Twitter Thread Calendar" || 
                        props.templateValue === "YouTube Video Calendar" ? (props.templateValue === 'Generate Pin Titles' || props.templateValue === 'Keywords For Pinterest' || props.templateValue === 'Generate Pin Descriptions' ? "10" : "8") : "12"
                    ) + " mt-2"}
                > 
                    <Form.Label htmlFor="topic">{
                    props.templateValue === "Pinterest Hashtag Generator" || props.templateValue === "TikTok Hashtag Generator" ? "Content/Topic" : "Topics"}</Form.Label>
                    {props.templateValue === "Generate Instagram Carousel" || 
                    props.templateValue === "Generate Instagram Caption" ||
                    props.templateValue === "Pinterest Hashtag Generator" ? <Form.Control
                        value={topicValue}
                        as='textarea' 
                        rows={3}
                        id="topic"
                        aria-describedby="Topic"
                        onChange={onChangeTopicValue} 
                    /> : <Form.Control
                        value={topicValue}
                        type="text"
                        id="topic"
                        aria-describedby="Topic"
                        onChange={onChangeTopicValue} 
                    />}                   
                </div> : <></>}
                {props.templateValue === 'Twitter Hashtag Generator' ? <div className="col-sm-10  mt-2">
                    <Form.Label htmlFor="content">Content </Form.Label>
                    <Form.Control 
                        id="content"
                        value={contentValue}
                        as='textarea' 
                        onChange={onChangeContent}
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "LinkedIn Bio Generator" ? <div 
                    className="col-sm-10 mt-2"
                >
                    <Form.Label htmlFor="JobDescription">Job Description</Form.Label>
                    <Form.Control 
                        id="JobDescription"
                        value={jobDescriptionValue}
                        onChange={onChangeJobDescription}
                        as='textarea' 
                        rows={2}
                    />
                </div> : <></>}
                {props.templateValue === "LinkedIn Comment Generator" || props.templateValue === "LinkedIn Hashtag Generator"  ? <div 
                    className="col-sm-12 mt-2"
                >
                    <Form.Label htmlFor="Post">Post</Form.Label>
                    <Form.Control 
                        id="Post"
                        value={postValue}
                        onChange={onChangePost}
                        as='textarea' 
                        rows={2}
                    />
                </div> : <></>}
                {props.templateValue === "LinkedIn Connection Message" ? <div 
                    className="col-sm-10 mt-2"
                >
                    <Form.Label htmlFor="Name">Name</Form.Label>
                    <Form.Control 
                        id="Name"
                        value={nameValue}
                        onChange={onChangeName}
                        type='text'
                    />
                </div> : <></>}
                {props.templateValue === "LinkedIn Comment Generator" || 
                props.templateValue === "LinkedIn Bio Generator" ||
                props.templateValue === "LinkedIn Connection Message" || 
                props.templateValue === "LinkedIn Ad Generator" || 
                props.templateValue === "TikTok Script Writer"  ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="Length">Length</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={lengthValue}
                        id="Length"
                        aria-describedby="Length"
                        onChange={onChangeLength}
                    />
                </div> : <></>}
                {props.templateValue === "LinkedIn Connection Message" ? <div 
                    className="col-sm-12 mt-2"
                >
                    <Form.Label htmlFor="TitleCompany">Title & Company</Form.Label>
                    <Form.Control 
                        id="TitleCompany"
                        value={titleCompanyValue}
                        onChange={onChangeTitleCompany}
                        type='text'
                    />
                </div> : <></>}
                {props.templateValue === 'LinkedIn Comment Generator' ? <div className="col-sm-10  mt-2">
                    <Form.Label htmlFor="CommentType">Comment Type</Form.Label>
                    <Form.Control
                        value={commentTypeValue}
                        type="text"
                        id="CommentType"
                        aria-describedby="Comment Type"
                        onChange={onChangeCommentType} 
                    />
                </div> : <></>}
                {props.templateValue === 'Twitter Personalized Bio' ? <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="JobRole">Job Role</Form.Label>
                    <Form.Control
                        value={jobRoleValue}
                        type="text"
                        id="JobRole"
                        aria-describedby="JobRole"
                        onChange={onChangeJobRole} 
                    />
                </div> : <></>}
                {props.templateValue === "LinkedIn Post Creator" || 
                props.templateValue === 'Twitter Personalized Bio' ? <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="industry">Industry </Form.Label>
                    <Form.Control
                        value={industryValue}
                        type="text"
                        id="industry"
                        aria-describedby="Industry"
                        onChange={onChangeIndustry} 
                    />
                </div> : <></>}
                {props.templateValue === "LinkedIn Post Creator" && <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="PostLength ">Post Length  </Form.Label>
                    <Form.Control
                        value={postLengthValue}
                        type="text"
                        id="PostLength"
                        aria-describedby="Post Length "
                        onChange={onChangePostLength} 
                    />
                </div>}
                {props.templateValue === "LinkedIn Post Calendar" ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="Postsperweek">Posts per week</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={postsperweekValue}
                        id="Postsperweek"
                        aria-describedby="Posts per week"
                        onChange={onChangePostsperweek}
                    />
                </div> : <></>}
                {props.templateValue === "Facebook Group Calendar" || 
                props.templateValue === 'Instagram Post Calendar' || 
                props.templateValue === "LinkedIn Post Calendar" ||
                props.templateValue === "Pinterest Pin Calendar" || 
                props.templateValue === "TikTok Post Calendar" || 
                props.templateValue === "Twitter Thread Calendar" || 
                props.templateValue === "Facebook Post Calendar" ||
                props.templateValue === "YouTube Video Calendar" ? <div className={"col-sm-" + (props.templateValue === "LinkedIn Post Calendar" || props.templateValue === "Twitter Thread Calendar" || props.templateValue === "YouTube Video Calendar" ? "2" : "6") + " mt-2"}>
                    <Form.Label htmlFor="totalMonths">Total months</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalMonthsValue}
                        id="totalMonths"
                        aria-describedby="Total Months"
                        onChange={onChangeTotalMonths}
                    />
                </div> : <></>}
                {props.templateValue === 'Facebook Post Ideas' || props.templateValue === "Facebook Group Post" ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="TotalPosts">Total Posts: </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalPostsValue}
                        id="TotalPosts"
                        aria-describedby="Total Posts"
                        onChange={onChangeTotalPosts}
                    />
                </div> : <></>} 
                {props.templateValue === 'Facebook Post Ideas' || 
                props.templateValue === "Facebook Group Calendar" || 
                props.templateValue === "Facebook Post Calendar" ||
                props.templateValue === "TikTok Script Writer"  ? <div className={"col-sm-10  mt-2"}> 
                    <Form.Label htmlFor="Audience">Audience</Form.Label>
                    <Form.Control
                        value={audienceValue}
                        type="text"
                        id="Audience"
                        aria-describedby="Audience"
                        onChange={onChangeAudience} 
                    />                   
                </div> : <></>}
                {props.templateValue === "YouTube Video Calendar" ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="Videosperweek ">Videos per week : </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={videosPerWeekValue}
                        id="Videosperweek"
                        aria-describedby="Videos per week"
                        onChange={onChangeVideosPerWeek}
                    />
                </div> : <></>}
                {props.templateValue === "Facebook Group Calendar" || 
                props.templateValue === "Pinterest Pin Calendar" || 
                props.templateValue === "TikTok Post Calendar" ||
                props.templateValue === "Facebook Post Calendar" ||
                props.templateValue === "Twitter Thread Calendar" ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="Threadsperweek ">Threads per week : </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={threadsPerWeekValue}
                        id="Threadsperweek"
                        aria-describedby="Threads per week"
                        onChange={onChangeThreadsPerWeek}
                    />
                </div> : <></>} 
                {props.templateValue === 'Instagram Post Calendar' ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="Articlesperweek ">Articles per week : </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={articlesPerWeekValue}
                        id="Articlesperweek"
                        aria-describedby="Threads per week"
                        onChange={onChangeArticlesPerWeek}
                    />
                </div> : <></>}
                {props.templateValue === "LinkedIn Hashtag Generator" ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="Total">Total</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalValue}
                        id="Total"
                        aria-describedby="Total"
                        onChange={onChangeTotal}
                    />
                </div> : <></>}
                {props.templateValue === 'Keywords For Pinterest' && <div className="col-sm-3  mt-2">
                    <Form.Label htmlFor="totalKeywords">Total Keywords</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalKeywordsValue}
                        id="totalKeywords"
                        aria-describedby="Total Keywords"
                        onChange={onChangeTotalKeywords}
                    />
                </div>}
                {props.templateValue === 'Generate Pin Titles' ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="totalTitles">Total Titles </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalTitlesValue}
                        id="totalTitles"
                        aria-describedby="Total Titles"
                        onChange={onChangeTotalTitles}
                    />
                </div> : <></>}
                {props.templateValue === 'Pinterest Hashtag Generator' || 
                props.templateValue === "TikTok Hashtag Generator" || 
                props.templateValue === 'Twitter Hashtag Generator'  ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="TotalHashtags">Total Hashtags </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalHashtagsValue}
                        id="TotalHashtags"
                        aria-describedby="Total Hashtags"
                        onChange={onChangeTotalHashtags}
                    />
                </div> : <></>}
                {props.templateValue === 'Generate Pin Descriptions' && <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="totalDescriptions">Total Desc</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalDescriptionsValue}
                        id="totalDescriptions"
                        aria-describedby="Total Descriptions"
                        onChange={onChangeTotalDescriptions}
                    />
                </div>}
                {props.templateValue === 'TikTok Video Ideas' && <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="totalIdeas">Total Ideas</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalIdeasValue}
                        id="totalIdeas"
                        aria-describedby="Total Ideas"
                        onChange={onChangeTotalIdeas}
                    />
                </div>}
                {props.templateValue === "Respond to Customers on Twitter"  ? <div 
                    className="col-sm-12  mt-2"
                >
                    <Form.Label htmlFor="CustomerTweet">Customer Tweet:</Form.Label>
                    <Form.Control 
                        id="CustomerTweet"
                        value={customerTweetValue}
                        as='textarea' 
                        rows={3}
                        onChange={onChangeCustomerTweet}
                    />
                </div> : <></>}  
                {props.templateValue === "YouTube Transcript to Article" ? <div 
                    className="col-sm-12  mt-2"
                >
                    <Form.Label htmlFor="Transcript">Transcript</Form.Label>
                    <Form.Control 
                        id="Transcript"
                        value={transcriptValue}
                        as='textarea' 
                        rows={3}
                        onChange={onChangeTranscript}
                    />
                </div> : <></>}
                {props.templateValue === "Generate Pin Descriptions" || 
                props.templateValue === "YouTube Title &Descriptions" || 
                props.templateValue === "YouTube Transcript to Article" ? <div 
                    className="col-sm-12  mt-2"
                >
                    {props.templateValue === "YouTube Transcript to Article" ? <>
                    <Form.Label htmlFor="ptemplate">Keywords:</Form.Label>
                    <Form.Control 
                        id="ptemplate"
                        value={keywordsValue}
                        type="text"
                        onChange={onChangeKeywords}
                    /></> : <>
                    <Form.Label htmlFor="ptemplate">Keywords:</Form.Label>
                    <Form.Control 
                        id="ptemplate"
                        value={keywordsValue}
                        as='textarea' 
                        rows={3}
                        onChange={onChangeKeywords}
                    /></>}
                </div> : <></>} 
                {props.templateValue === 'YouTube Ads Generator' ? <div className="col-sm-4  mt-2">
                    <Form.Label htmlFor="totalHeadlines">Total Headlines</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalHeadlines}
                        id="totalHeadlines"
                        aria-describedby="Total Headlines"
                        onChange={onChangeTotalHeadlines}
                    />
                </div> : <></>}
                {props.templateValue === 'YouTube Ads Generator' ? <div className="col-sm-4  mt-2">
                    <Form.Label htmlFor="headlinesLength">Headlines Length: </Form.Label>
                    <Form.Control
                        type="text"
                        value={headlinesLengthValue}
                        id="headlinesLength"
                        aria-describedby="Headlines Length"
                        onChange={onChangeHeadlinesLength}
                    />
                </div> : <></>}
                {props.templateValue === 'YouTube Ads Generator' ? <div className="col-sm-4  mt-2">
                    <Form.Label htmlFor="descriptionLength">Description Length: </Form.Label>
                    <Form.Control
                        type="text"
                        value={descriptionLengthValue}
                        id="descriptionLength"
                        aria-describedby="Description Length"
                        onChange={onChangeDescriptionLength}
                    />
                </div> : <></>}
                {props.templateValue === "YouTube Script Creator" ||
                props.templateValue === 'YouTube Shorts Script' || 
                props.templateValue === 'YouTube Ads Generator' || 
                props.templateValue === 'YouTube Tags Generator'  ? <div 
                    className={"col-sm-"+(props.templateValue === 'YouTube Tags Generator' ? "10" : "12")+" mt-2"}
                >
                    <Form.Label htmlFor="videoDescription">{props.templateValue === 'YouTube Tags Generator' ? 'Video Description/Transcript' : 'Video Description'}</Form.Label>
                    <Form.Control 
                        id="videoDescription"
                        value={videoDescriptionValue}
                        as='textarea' 
                        rows={3}
                        onChange={onChangeVideoDescription}
                    />
                </div> : <></>} 
                {props.templateValue === 'YouTube Tags Generator'  ? <div 
                    className="col-sm-2  mt-2"
                >
                    <Form.Label htmlFor="TotalTags">Total Tags</Form.Label>
                    <Form.Control 
                        type="number"
                        min={1}
                        max={1000}
                        id="TotalTags"
                        value={totalTagsValue}
                        onChange={onChangeTotalTags}
                    />
                </div> : <></>} 
                {props.templateValue === "Convert Article Into Twitter Thread"  && <div className="col-sm-12  mt-2">  
                    <Form.Label htmlFor="Article">Article</Form.Label>
                    <Form.Control 
                        id="Article"
                        value={articleValue}
                        onChange={onChangeArticle}
                        as='textarea' 
                        rows={10}
                    />
                </div>}
                {props.templateValue === 'YouTube Script Creator' || 
                props.templateValue === 'YouTube Shorts Script' || 
                props.templateValue === "YouTube Title &Descriptions" ? <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="callToAction">Call To Action </Form.Label>
                    <Form.Control
                        value={callToActionValue}
                        type="text"
                        id="callToAction"
                        aria-describedby="Call To Action "
                        onChange={onChangeCallToAction} 
                    />
                </div> : <></>}
                {/* <div className="col-sm-12  mt-2">  
                    <Form.Label htmlFor="ptemplate">Prompt Template</Form.Label>
                    <Form.Control 
                        id="ptemplate"
                        value={textareaValue}
                        onChange={onChangeTextarea}
                        as='textarea' 
                        rows={10}
                    />
                </div> */}
            </div>
            <div className="row">
                <div className="col-sm-12  mt-2">
                    <Button id="executeTemplate" onClick={executeTemplateButton} disabled={getButtonVisiblety()}>Execute Template</Button>
                </div>
            </div>
        </div>
    )   
}

export default SocialMedia;


const indianLanguages: any = {
    "Assamese":"Assamese",
    "Bengali":"Bengali",
    "Bodo":"Bodo",
    "Dogri":"Dogri",
    "English": "English",
    "Gujarati":"Gujarati",
    "Hindi":"Hindi",
    "Kannada":"Kannada",
    "Kashmiri":"Kashmiri",
    "Konkani":"Konkani",
    "Maithili":"Maithili",
    "Malayalam":"Malayalam",
    "Marathi":"Marathi",
    "Meitei":"Meitei",
    "Nepali":"Nepali",
    "Odia":"Odia",
    "Punjabi":"Punjabi",
    "Sanskrit":"Sanskrit",
    "Santali":"Santali",
    "Sindhi":"Sindhi",
    "Tamil":"Tamil",
    "Telugu":"Telugu",
    "Urdu":"Urdu",
    "Other languages": "Other languages"
}

const languages: any = {
    "arabic": "Arabic",
    "bulgarian": "Bulgarian",
    "burmese": "Burmese",
    "czech": "Czech",
    "danish": "Danish",
    "dutch": "Dutch",
    "french": "French",
    "german": "German",
    "greek": "Greek",
    "hungarian": "Hungarian",
    "indonesian": "Indonesian",
    "italian": "Italian",
    "japanese": "Japanese",
    "javanese": "Javanese",
    "korean": "Korean",
    "mandarin chinese": "Mandarin Chinese",
    "polish": "Polish",
    "portuguese": "Portuguese",
    "romanian": "Romanian",
    "russian": "Russian",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "thai": "Thai",
    "turkish": "Turkish",
    "ukranian": "Ukranian",
    "urdu": "Urdu",
    "vietnamese": "Vietnamese",
    "wu chinese": "Wu Chinese",
    "yue chinese": "Yue Chinese"
}

const voicetones: any = {
    "authoritative": "Authoritative",
    "caring": "Caring",
    "casual": "Casual",
    "cheerful": "Cheerful",
    "coarse": "Coarse",
    "conservative": "Conservative",
    "conversational": "Conversational",
    "creative": "Creative",
    "dry": "Dry",
    "edgy": "Edgy",
    "enthusiastic": "Enthusiastic",
    "expository": "Expository",
    "formal": "Formal",
    "frank": "Frank",
    "friendly": "Friendly",
    "fun": "Fun",
    "funny": "Funny",
    "humorous": "Humorous",
    "informative": "Informative",
    "irreverent": "Irreverent",
    "journalistic": "Journalistic",
    "matteroffact": "Matter of fact",
    "nostalgic": "Nostalgic",
    "objective": "Objective",
    "passionate": "Passionate",
    "poetic": "Poetic",
    "playful": "Playful",
    "professional": "Professional",
    "provocative": "Provocative",
    "quirky": "Quirky",
    "respectful": "Respectful",
    "romantic": "Romantic",
    "sarcastic": "Sarcastic",
    "serious": "Serious",
    "smart": "Smart",
    "snarky": "Snarky",
    "subjective": "Subjective",
    "sympathetic": "Sympathetic",
    "trendy": "Trendy",
    "trustworthy": "Trustworthy",
    "unapologetic": "Unapologetic",
    "upbeat": "Upbeat",
    "witty": "Witty"
}
const writingStyles: any = {
    "academic": "Academic",
    "analytical": "Analytical",
    "argumentative": "Argumentative",
    "conversational": "Conversational",
    "creative": "Creative",
    "critical": "Critical",
    "descriptive": "Descriptive",
    "epigrammatic": "Epigrammatic",
    "epistolary": "Epistolary",
    "expository": "Expository",
    "informative": "Informative",
    "instructive": "Instructive",
    "journalistic": "Journalistic",
    "metaphorical": "Metaphorical",
    "narrative": "Narrative",
    "persuasive": "Persuasive",
    "poetic": "Poetic",
    "satirical": "Satirical",
    "technical": "Technical"
}